export default (params) => ({
  trigger: {
    name: 'product_plus.open_overlay',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'vendor_free_with',
          'nespresso',
          'norton',
          'free_washing',
          'free_drying',
        ],
      },
    },
    event: {
      name: 'select_content',
    },
    nonInt: false,
  },
});
